/**
 * Constants
 * 專案中使用的常數定義
 * 替代 @jetthai/cuora 的 constant 模組
 */

export const MY_FAVORITE = 'MyFavorite'
export const GAME_SEARCH = 'GameSearch'
export const GAME_TYPE_LIST = [
  { typeId: 'SLOT', name: 'Slots', gameTypeMappingId: 1 },
  { typeId: 'FISH', name: 'Fishing', gameTypeMappingId: 2 },
  { typeId: 'ARCADE', name: 'Arcades', gameTypeMappingId: 3 },
  { typeId: 'LOTTERY', name: 'Lottery', gameTypeMappingId: 4 },
  { typeId: 'CARD', name: 'Card', gameTypeMappingId: 5 },
  { typeId: 'TABLE', name: 'Table', gameTypeMappingId: 6 },
  { typeId: 'BINGO', name: 'Bingo', gameTypeMappingId: 7 },
  { typeId: 'LIVE', name: 'Live', gameTypeMappingId: 8 },
  { typeId: 'SCRATCHCARDS', name: 'Scratch Cards', gameTypeMappingId: 9 },
  { typeId: 'EGAME', name: 'E-Game', gameTypeMappingId: 10 },
  { typeId: 'BONUS', name: 'Bonus', gameTypeMappingId: 11 },
  { typeId: 'BALL', name: 'Ball', gameTypeMappingId: 12 },
  { typeId: 'PACHINKO', name: 'Pachinko', gameTypeMappingId: 13 },
  { typeId: 'GRAPH', name: 'Graph', gameTypeMappingId: 14 },
  { typeId: 'TURBO', name: 'Turbo', gameTypeMappingId: 15 },
  { typeId: 'SPORT', name: 'Sports', gameTypeMappingId: 16 },
]

// 活動類型
export const ACTIVITY_TYPES = {
  INSTANT_REBATE: 4, // 實時反水
  MINI_GAME: 92, // Mini Game
  CASH_RAIN: 34, // 紅包雨
}

// 活動模板
export const ACTIVITY_TEMPLATES = {
  INSTANT_REBATE: 'Template_layer_instant_rebate',
}
